import { Helmet } from 'react-helmet-async';

import { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import { Stack, Paper, Button, Container, Typography, Tabs, Tab, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import ContactInforamtion from 'src/components/Company/ContactInforamtion';
import BusinessInforamtion from 'src/components/Company/BusinessInforamtion';
import CompanyInforamtion from 'src/components/Company/CompanyInforamtion';
import BusinessDetails from 'src/components/Company/BusinessDetails';
import ForeignWorkerInformation from 'src/components/Company/ForeignWorkerInformation';
import CreateCompany from 'src/components/Company/CreateCompany';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CompanyPage() {
  let { id } = useParams();
  const navigate = useNavigate();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const SaveCompany = async (event) => {};
  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  return (
    <>
      <Helmet>
        <title> Employers | Immigration System </title>
      </Helmet>
      <Container>
        <Box
          p={4}
          component={Paper}
          boxShadow={3}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Employer
            </Typography>

            <Stack direction="row" spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              {/* <Button type="submit" variant="contained">
                Save
              </Button> */}
            </Stack>
          </Stack>

          <Box component={Paper} p={1}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="primary tabs example"
            >
              <Tab label="Create Company" {...a11yProps(0)} />
              <Tab disabled label="Contact Information" {...a11yProps(1)} />
              <Tab disabled label="Business Information" {...a11yProps(2)} />
              <Tab disabled label="Company Information" {...a11yProps(3)} />
              <Tab disabled label="Business Details" {...a11yProps(4)} />
              <Tab disabled label="Foreign Worker Information" {...a11yProps(5)} />
            </Tabs>

            <SwipeableViews axis="x-reverse" index={value} onChangeIndex={handleChangeIndex}>
              <TabPanel value={value} index={0}>
                <CreateCompany setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <ContactInforamtion clicked />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <BusinessInforamtion />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <CompanyInforamtion />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <BusinessDetails />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <ForeignWorkerInformation />
              </TabPanel>
            </SwipeableViews>
          </Box>
        </Box>
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
